(() => {
  angular
    .module('gm.common.filters')
    .filter('gmStartFrom', gmStartFrom);

  function gmStartFrom() {
    'ngInject';

    return function gmStartFromFilter(input, origStart) {
      const start = parseInt(origStart, 10);
      return input.slice(start);
    };
  }
})();
